export type SearchCategory =
  | "pages"
  | "couples"
  | "masterData"
  | "superAdmins"
  | "subAdmins"
  | "committee"
  | "retreatSubAdmins"
  | "projected"
  | "inSetup"
  | "registrationOpen"
  | "upcoming"
  | "deleted"
  | "roster"
  | "registration"
  | "tickets"
  | "closing";

export const SEARCH_CATEGORY_LABELS: Record<SearchCategory, string> = {
  pages: "Pages",
  couples: "Couples",
  masterData: "Master Data",
  superAdmins: "Super Admins",
  subAdmins: "Sub Admins",
  committee: "Steering Committee",
  retreatSubAdmins: "Retreat Sub Admins",
  projected: "Projected Retreats",
  inSetup: "Retreats in Setup",
  registrationOpen: "Registration Open",
  upcoming: "Upcoming Retreats",
  deleted: "Deleted Retreats",
  roster: "Retreat Roster",
  registration: "Registration Pages",
  tickets: "Tickets",
  closing: "Retreat Closing",
};

export const SEARCH_CATEGORY_ORDER: SearchCategory[] = [
  "pages",
  "couples",
  "masterData",
  "superAdmins",
  "subAdmins",
  "committee",
  "retreatSubAdmins",
  "projected",
  "inSetup",
  "registrationOpen",
  "upcoming",
  "deleted",
  "roster",
  "registration",
  "tickets",
  "closing",
];

export interface SearchResult {
  id: string;
  category: SearchCategory;
  title: string;
  subtitle?: string;
  badge?: string;
  path: string;
  state?: Record<string, unknown>;
}

export interface SearchAccess {
  isAuthenticated: boolean;
  userId: string | number | null;
  userRole: string;
  isFullAdmin: boolean;
  isAdminRole: boolean;
  hasCoupleProfile: boolean;
  canViewCouples: boolean;
  canViewMasterData: boolean;
  canViewAdminDashboard: boolean;
  canViewTickets: boolean;
  canViewClosures: boolean;
  canManageRetreats: boolean;
  canViewProjected: boolean;
  canViewRoster: boolean;
  canViewUpcoming: boolean;
  actor: {
    actorName: string;
    actorRole: string;
    actorUserId: string | number | null;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    accessId: string | number | null;
  };
}

export interface RunGlobalSearchOptions {
  onPartial?: (results: SearchResult[]) => void;
  isCancelled?: () => boolean;
}

export const SEARCH_LIMIT = 5;
export const ROSTER_RETREAT_CAP = 10;
export const MIN_QUERY_LENGTH = 2;
